import React, { Component } from 'react';
import './Home.css';
import Navbar from './Navbar';
import logo from '../healthfy-incentivos.jpg';

class Incentivar extends Component {

	render() {
		return (
	  		<div>

	    		<Navbar />
	    		<img className="tela" src={logo} alt="logo"></img>
	  		</div>
		);
	}
}

export default Incentivar;


// WEBPACK FOOTER //
// ./src/components/Incentivar.js